import React from 'react';
import styled from 'styled-components';
import loadingGif from 'assets/yuhu-loading.gif';

const StyledImgContainer = styled.div`
  display: flex;
  margintop: 32px;
`;

const StyledLoader = styled.img`
  width: 200px;
  margin: auto;
`;

const Loader = name => {
  if (name) return null;

  return (
    <StyledImgContainer shouldRender>
      <StyledLoader src={loadingGif} alt="loader" />
    </StyledImgContainer>
  );
};

export default Loader;
